import React from "react";
import { connect } from "react-redux";
import { updateSDEAnalysis } from "../../../../store/modules/qualityOfEarnings/actions";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import FinancialHandler from "../../../../handlers/FinancialHandler";
import YearBar from "../YearBar";
import Subtitle from "../Subtitle";
import Item from "./Item";

function Matrix({
  currentCompanySDEAnalysis,
  dispatchUpdateSDEAnalysis,
  labelTitle,
}) {
  const label = labelTitle.replace(/ /g, ""); //Must get rid of spaces to get variables by names

  const handleChange = (label, value, id, type, key = "") => {
    dispatchUpdateSDEAnalysis(label, value, id, type, key);
  };
  
  const handleOnClickGPT = async () => {
    if(currentCompanySDEAnalysis["matrix" + label + "Adj"]?.length > 1) {
      handleChange(label, "Generating...", 0, "note");
      const note = await FinancialHandler.fetchGPTSDENoteGeneration(
        labelTitle,
        currentCompanySDEAnalysis.yearsFormatted,
        currentCompanySDEAnalysis.totalSalesRevenue,
        currentCompanySDEAnalysis.EBITDA,
        currentCompanySDEAnalysis["matrix" + label + "Adj"],
        currentCompanySDEAnalysis["total" + label + "Adj"],
        currentCompanySDEAnalysis["EBITDA" + label + "Adj"],
      );
      handleChange(label, note, 0, "note");
    }
    else handleChange(label, "Please provide enough data", 0, "note");
  }

  return (
    <div className="overflow-none pb-10">
      <Subtitle
        title={
          label == "OwnerSalary"
            ? "Ownership Salaries"
            : "EBITDA " + labelTitle + " Adjusted"
        }
      />

      <YearBar pre="Items" after="Comments" data={currentCompanySDEAnalysis?.yearsFormatted} />

      {currentCompanySDEAnalysis["matrix" + label + "Adj"]?.map((item) => (
        <div className="flex items-center mt-1">
          <div className="flex" style={{ minWidth: "18em" }}>
            <TextareaAutosize
              style={rowStyle.tableItems}
              aria-label="minimum height"
              minRows={1}
              maxRows={1}
              defaultValue={item.name}
              onBlur={(e) => handleChange(label, e.target.value, item.id, "name")}
            />
          </div>
          <div className="flex">
            {item.series.map((price) => (
              <div className="flex items-center" style={{ width: "10em" }}>
                <BVAInput
                  startAdornment
                  startAdornmentLabel="$ "
                  width="95%"
                  size="small"
                  key={price.date}
                  value={price.value}
                  onChange={(value) => handleChange(label, value, item.id, "series", price.date)}
                />
              </div>
            ))}
          </div>
          <div className="flex" style={{ minWidth: "25em" }}>
            <TextareaAutosize
              style={rowStyle.tableComments}
              aria-label="minimum height"
              minRows={1}
              maxRows={1}
              defaultValue={item.comment}
              onBlur={(e) => handleChange(label, e.target.value, item.id, "comment")}
            />
          </div>
        </div>
      ))}

      <Item
        name={
          label == "OwnerSalary"
            ? "Owner Salary Totals"
            : "Total " + labelTitle + " Adjusted"
        }
        data={currentCompanySDEAnalysis["total" + label + "Adj"]}
        bold={label == "OwnerSalary"}
      />

      {label == "OwnerSalary" ?
        (<>
          <Item
            name={"Social Security Taxes"}
            data={currentCompanySDEAnalysis["totalSocialSecurityTaxes"]}
          />
          <Item
            name={"Medicare Taxes"}
            data={currentCompanySDEAnalysis["totalMedicareTaxes"]}
          />
          <Item
            name={"Owner Salary and Payroll Taxes"}
            data={currentCompanySDEAnalysis["totalOwnerSalaryandPayrollTaxes"]}
            bold={true}
          />
        </>)
        :
        (<></>)
      }

      <Item
        name={
          label == "OwnerSalary"
            ? "Discretionary Owner Earnings"
            : "EBITDA " + labelTitle + " Adjusted"
        }
        data={currentCompanySDEAnalysis["EBITDA" + label + "Adj"]}
        bold={true}
      />

      <Item
        name={
          label == "OwnerSalary"
            ? "Discretionary Owner Earnings Margin"
            : "EBITDA " + labelTitle + " Adjusted Margin"
        }
        data={currentCompanySDEAnalysis["EBITDA" + label + "Margin"]}
        margin={true}
      />

      {/* Analyst note */}
      <div className="data-bottom pt-5">
        <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
        <textarea
          className="analystNote px-3 py-1"
          style={{ width: currentCompanySDEAnalysis?.yearsFormatted?.length * 10 + 43 + "em" }}
          rows={3}
          value={currentCompanySDEAnalysis["note" + label]}
          onChange={(e) => handleChange(label, e.target.value, 0, "note")}
        />
      </div>

    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanySDEAnalysis: state.qualityOfEarnings.currentCompanySDEAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateSDEAnalysis(label, value, id, type, key) {
    dispatch(updateSDEAnalysis(label, value, id, type, key));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Matrix);
